import { ReactNode } from "react";
import { Outlet } from "react-router-dom";

export default function FullTopBarLayout(props: { fullTopBarEl: ReactNode }) {
  return (
    <>
      {props.fullTopBarEl}
      <div className="top-bar-offset">
        <Outlet />
      </div>
    </>
  );
}
